import { valida_existe_dni_url, obtiene_formatos_url, obtiene_formatos_completados_url, valida_beneficiario_url } from "./urlBase"
import { apiCall } from "./apiCall";


async function validaDNI(estudiante) {

    try {
        // const token = localStorage.getItem('token')
        // const request = client(token)
        // const resp = await request.call( 'POST', valida_existe_dni_url, estudiante )
        console.log("aqui0");
        console.log(estudiante);
        console.log("aqui");
        const resp = await apiCall('POST', valida_existe_dni_url, estudiante);
        const response = resp.data;
        //const stat = status.val
        //console.log('stat', status.val)
        // valida si se puede cerrar desde aqui
        /* if (resp.data.Message = '0k')
             window.location.reload();*/
        if (response.Success) {
            return response;
        }
        else {
            console.log('estudianteHelper', '37');
            throw response;
        }

    } catch (e) {
        console.log('estudianteHelper', '42');
        throw e;
    }
}

const obtieneFormatosCompletados = async ( estudiante ) => {

    try {
  
        const resp = await apiCall( 'POST', obtiene_formatos_completados_url, estudiante )
        const response = resp.data
        console.log('estud25', resp.data.Message)

        //const resp1 = await apiCall( 'POST', obtiene_formatos_completados_url, estudiante )
        //const response1  = response.data.val
        //console.log('estud22', response1)

        if ( response.Success ) {
            return response
        }
        else {
            console.log('estudianteHelper', '41')
            throw response
        }

 

    } catch ( e ) {
        console.log('estudianteHelper', '47')
        throw e
    }
}

const obtieneFormatos = async ( estudiante) => {

  try {
  
        const resp = await apiCall( 'POST', obtiene_formatos_url, estudiante )
        const response = resp.data
        console.log('estud50', resp.data.Message)
        console.log('estud55', resp.status)
       
     
  

        if ( response.Success ) {
            return response
        }
        else {
            console.log('estudianteHelper', '41')
            throw response
        }

        /* */

    } catch ( e ) {
        console.log('estudianteHelper', '47')
        throw e
    }
}


const validaBeneficiario = async ( estudiante ) => {

    try {
        console.log(estudiante)
        const resp = await apiCall( 'POST', valida_beneficiario_url, estudiante )
        const response = resp.data

        if ( response.Success ) {
            return response
        }
        else {
            console.log('estudianteHelper', '37')
            throw response
        }

    } catch ( e ) {
        console.log('estudianteHelper', '42')
        throw e
    }
}

export {
    validaDNI,
    obtieneFormatos,
    obtieneFormatosCompletados,
    validaBeneficiario
}